module.exports = __webpack_public_path__ + "static/img/3.508edc7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/sp/3.png
// module id = K3wi
// module chunks = 0